import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';

import { ActionContext } from 'vuex';

import { ActionClass, AnalyticsState, ContextState, PeriodsData } from '../../../models';

import { CONTEXT_CONSTS } from '../../context/context.consts';
import { LoadDistDataAction } from '../actions/load-dist-data.action';
import { ANALYTICS_CONSTS } from '../analytics.consts';

export class LoadSessionsDataAction implements ActionClass {

  public static async execute({ dispatch, commit, state, rootGetters }: ActionContext<AnalyticsState, any>): Promise<void> {
    const currentSessionsData = state.data.overall.sessions;
    const reportId = StatsReportsIdsEnum.DAILY_SESSION;
    const newSessionsData: Partial<PeriodsData> = {};
    if (!currentSessionsData || !currentSessionsData.currentPeriod) {
      newSessionsData.currentPeriod = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
        id: reportId,
        params: {}
      });
    }
    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const periodToCompare = LoadDistDataAction.getPeriodToCompare(context);
    if (!!periodToCompare && (!currentSessionsData || !currentSessionsData[periodToCompare])) {
      const periodToCompareDates = LoadDistDataAction.getPeriodToCompareDates(periodToCompare, context);
      newSessionsData[periodToCompare] = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
        id: reportId,
        params: {
          startDate: periodToCompareDates[0],
          endDate: periodToCompareDates[1]
        }
      });
    }
    if (!!Object.keys(newSessionsData).length) {
      commit(ANALYTICS_CONSTS.mutations.setSessionsData, {
        data: newSessionsData
      });
    }
  }
}
